import { StringCellEditor, StringCellRenderer } from './StringCellInnerComponents'
import { DataGridCell } from './types'

export const StringCell: DataGridCell = {
    provideRenderer: StringCellRenderer,
    provideEditor: StringCellEditor,
}
